import { Grid, makeStyles } from '@material-ui/core';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import CustomSearch from '../../shared/CustomSearch';
import DealershipFilter from './DealershipFilter';
import { sortDealerships, sortLabel } from '../utils';
import SelectAll from './SelectAll';
import DealershipList from './DealershipList';

const useStyles = makeStyles({
  detailsContainer: {
    padding: '8px 0px 0px 20px',
    background: 'rgba(242, 244, 247, 1)',
    height: '310px',
    overflow: 'hidden',
    flexGrow: 1,
  },
  bottomSheetBtnContainer: {
    position: 'sticky',
    bottom: 0,
    background: 'white',
    padding: '10px',
    zIndex: 10,
  },
});

const AddDealerships = ({ handleDataChange, data, handleSelectAll, filters, filterObjectInitial }) => {
  const classes = useStyles();
  const [dealerships, setDealerships] = useState([]);

  const [filteredDealershipArray, setFilteredDealershipArray] = useState([]);
  const [sortType, setSortType] = useState('Dealership ID');

  useEffect(() => {
    setArray(dealerships);
  }, [dealerships]);
  const setArray = useCallback(() => {
    setFilteredDealershipArray(dealerships);
  }, [dealerships]);

  const handleSearch = useCallback(
    ({ target: { value } }) => {
      const arr = dealerships?.filter((item) => item?.name.toLowerCase()?.includes(value.toLowerCase()));
      setFilteredDealershipArray([...arr]);
    },
    [dealerships],
  );

  const handleSort = useCallback(
    ({ target: { value } }) => {
      setSortType(sortLabel(value));
      const sortedDealerships = sortDealerships(filteredDealershipArray, value);
      setFilteredDealershipArray(sortedDealerships);
    },
    [filteredDealershipArray],
  );

  const handleAll = useCallback(
    ({ target: { checked } }) => {
      const allFilteredDealerships = filteredDealershipArray?.map((dealer) => dealer.id);
      handleSelectAll(allFilteredDealerships, checked);
    },
    [filteredDealershipArray, handleSelectAll],
  );

  return (
    <Grid container direction="column" style={{ height: '100%' }}>
      <Grid item style={{ margin: '16px 22px 16px 22px' }}>
        <CustomSearch placeholder="Search Dealership" handleSearch={handleSearch} />
      </Grid>
      <Grid item>
        <DealershipFilter
          departmentRoleIds={data?.departmentRoleIds}
          filters={filters}
          filterObjectInitial={filterObjectInitial}
          handleDealerships={(res) => setDealerships(res)}
          handleSort={handleSort}
          sortType={sortType}
        />
      </Grid>
      <Grid item>
        <SelectAll
          margin="16px 0px 16px 22px"
          dealershipCount={dealerships?.length || 0}
          selected={useMemo(
            () =>
              filteredDealershipArray?.every((item) => data?.dealerships?.includes(item?.id))[
                (filteredDealershipArray, data?.dealerships)
              ],
            [filteredDealershipArray, data?.dealerships],
          )}
          data={data}
          indeterminate={useMemo(
            () =>
              filteredDealershipArray?.some((item) => data?.dealerships?.includes(item?.id)) &&
              !filteredDealershipArray?.every((item) => data?.dealerships?.includes(item?.id)),
            [filteredDealershipArray, data?.dealerships],
          )}
          handleChange={handleAll}
        />
      </Grid>
      <Grid item className={classes.detailsContainer}>
        <DealershipList
          filteredDealershipArray={filteredDealershipArray}
          data={data}
          handleDataChange={handleDataChange}
        />
      </Grid>
    </Grid>
  );
};

export default AddDealerships;
